import { createRouter, createWebHistory } from "vue-router";

const routes = [
   {
      path: "/checkin/:checkin_id",
      name: "checkin",
      component: () => import("../views/CheckinView.vue"),
      meta: {
         title: "Información de tu servicio |  PGS",
      },
   },
   {
      path: "/:slug/book",
      name: "book",
      component: () => import("../views/BookView.vue"),
   },
   {
      path: "/:pathMatch(.*)*",
      name: "error404",
      component: () => import("../views/Error404View.vue"),
      meta: {
         title: "Página no encontrada | PGS",
      },
   },
];

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes,
});

router.beforeEach((to) => {
   document.title = to.meta?.title ?? " NIDO";
});

export default router;
